// src/features/register/registerThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { registerApi, type CaptchaPayload } from '../../api/registerApi';
import i18n from '../../i18n';
import type { CountryValue } from '../country/countrySlice';

export interface RegisterData {
    id?: string | null,
    email: string,
    password?: string,
    lastName: string,
    firstName: string,
    status: string,
    nbr_child?: number,
    phone: string,
    codeCountry: string,
    indicatif: string,
    country: CountryValue,
    captcha?: CaptchaPayload,
}

const resolveApiMessage = (message: unknown): string => {
    if (!message) return i18n.t('system.registerSuccess');
    if (typeof message === 'string') return message;
    if (typeof message === 'object') {
        const lang = (i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0];
        const byLang = (message as Record<string, unknown>)[lang];
        if (typeof byLang === 'string') return byLang;
        const fallback = (message as Record<string, unknown>).fr ?? (message as Record<string, unknown>).en ?? (message as Record<string, unknown>).ar;
        if (typeof fallback === 'string') return fallback;
    }
    return i18n.t('system.registerSuccess');
};

export const register = createAsyncThunk(
    'register/submit',
    async (data: RegisterData, thunkAPI) => {
        try {
            const response = await registerApi(data);
            const message = resolveApiMessage(response.data?.message);

            return {
                success: true,
                message,
            };
        } catch (err: any) {
            const message = resolveApiMessage(err?.response?.data?.message) || i18n.t('system.registerError');
            return thunkAPI.rejectWithValue(message);
        }
    }
);
